<template>
  <div class=" py-3 " style="background-color: white">
    <div class="d-flex justify-content-between align-items-center  pb-3 px-5" style="border-bottom: #D6D5D5 solid 1px ">
      <p class="mb-0" style="font-size: 16px; font-weight: 500;">Quản lý nhân sự gia sư</p>
      <button type="button" class="btn btn-success" @click="openAddTutorModal()">Thêm mới</button>
    </div>
    <div class="px-5">
      <div class="row mb-3 mt-11 ">
        <div class="col-md-2 mb-2">
          <p>Nhân sự</p>
          <el-input
              v-model="filters.keyword"
              placeholder="Nhập họ tên, mã, số điện thoại"
              clearable
              size="medium"
              @input="getListTutor(true)"
          />
        </div>
        <div class="col-md-2 mb-2">
          <p>Trình độ</p>
          <el-select v-model="filters.level" placeholder="Chọn trình độ" clearable style="width: 100%" size="medium"
                     @change="getListTutor(true)" multiple>
            <el-option
                v-for="level in levels"
                :key="level.id"
                :label="level.name"
                :value="level.id"
            />
          </el-select>
        </div>
        <div class="col-md-2 mb-2">
          <p>Trạng thái</p>
          <el-select v-model="filters.status" placeholder="Chọn trạng thái" clearable style="width: 100%" size="medium"
                     @change="getListTutor(true)">
            <el-option label="Hiển thị" :value="1"/>
            <el-option label="Ẩn" :value="0"/>
          </el-select>
        </div>
        <div class="col-md-2 mb-2" size="medium">
          <p>Thời gian tạo</p>
          <el-date-picker
              v-model="filters.dateRange"
              type="daterange"
              range-separator="đến"
              start-placeholder="Từ ngày"
              end-placeholder="Đến ngày"
              align="right"
              unlink-panels
              clearable
              @change="getListTutor(true)"
              value-format="yyyy-MM-dd"
              format="dd/MM/yyyy"
          />
        </div>
      </div>

      <!-- Bảng dữ liệu -->
      <el-table
          :data="mockTutors"
          border
          size="small"
          style="width: 100%"
          height="550"
          lazy
          v-loading="loading"
      >
        <el-table-column label="Mã nhân sự" prop=userId width="100"/>
        <el-table-column label="Họ và tên" prop="name"/>
        <el-table-column label="Số điện thoại" prop="phone"/>
        <el-table-column label="Trình độ" prop="level"/>
        <el-table-column label="Trạng thái" prop="status" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status ? 'success' : 'info'" size="small">
              {{ scope.row.status ? 'Hiển thị' : 'Ẩn' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="Thời gian tạo" prop="created_at"/>
        <el-table-column label="Hành động" width="140">
          <template slot-scope="scope">
            <button class="btn btn-xs btn-icon mr-2 btn-outline-info"
                    title="Tác vụ tuần" @click="openWeeklyTask(scope.row)">
              <i class="fa fa-calendar"></i>
            </button>
            <button class="btn btn-xs btn-icon mr-2 btn-outline-info"
                    title="Lịch đi làm" @click="openWeeklyWorkSchedule(scope.row)">
              <i class="far fa-calendar-alt"></i>
            </button>
            <a href="javascript:" title="Sửa" class="btn btn-xs btn-icon mr-2 btn-outline-info"
               @click="editTutor(scope.row.id,scope.row.name)">
              <i class="fas fa-pen-nib"></i>
            </a>
            <a title="Xóa" href="javascript:" class="btn btn-xs btn-icon btn-outline-danger"
               @click="deleteTutor(scope.row.id,scope.row.name)"><i class="fas fa-trash"></i></a>
          </template>
        </el-table-column>
      </el-table>

      <!-- Phân trang -->
      <div class="edu-paginate mx-auto text-center d-flex justify-content-between mt-4">
        <div class="spacer"></div>
        <paginate v-model="page" :page-count="lastPage" :page-range="3" :margin-pages="1"
                  :click-handler="clickCallback" :prev-text="'Trước'" :next-text="'Sau'"
                  :container-class="'pagination b-pagination'" :pageLinkClass="'page-link'"
                  :next-link-class="'next-link-item'" :prev-link-class="'prev-link-item'" :prev-class="'page-link'"
                  :next-class="'page-link'" :page-class="'page-item'">
        </paginate>
        <div class="right-div">Tổng số bản ghi: <span style="color: #0066FF">{{ totalTutor }}</span></div>
      </div>
    </div>

    <AddNewTutor :levels="levels" @loadList="getListTutor(true)"></AddNewTutor>
    <EditTutor :levels="levels" :idTutor="idTutor" @loadList="getListTutor(true)"></EditTutor>
    <WeeklyWorkSchedule :staff="tutor"></WeeklyWorkSchedule>
    <WeeklyTask :staff="tutor"></WeeklyTask>
  </div>
</template>

<script>
import AddNewTutor from "@/view/pages/tutor/human-management/AddNewTutor.vue";
import {DELETE_TUTOR, GET_LIST_TUTOR, GET_LIST_TUTOR_LEVEL} from "@/core/services/store/tutor/tutor.module";
import moment from "moment-timezone";
import EditTutor from "@/view/pages/tutor/human-management/EditTutor.vue";
import WeeklyWorkSchedule from "@/view/pages/tutor/human-management/WeeklyWorkSchedule.vue";
import WeeklyTask from "@/view/pages/tutor/human-management/WeeklyTask.vue";


export default {
  name: 'TutorStaffIndex',
  components: {WeeklyTask, WeeklyWorkSchedule, EditTutor, AddNewTutor},
  data() {
    return {
      filters: {
        keyword: '',
        level: [],
        status: null,
        dateRange: [],
      },
      levels: [],
      mockTutors: [],
      page: 1,
      lastPage: 1,
      totalTutor: 0,
      loading: false,
      idTutor: null,
      tutor: null
    };
  },
  computed: {},
  methods: {
    debounce(func) {
      let timeout;
      return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(context, args);
        }, 500);
      };
    },
    openAddTutorModal() {
      this.$bvModal.show('create-tutor')
    },
    async getListTutor(isFirstPage = false) {
      try {
        this.loading = true
        let payload = {
          page: isFirstPage ? 1 : this.page,
          keyword: this.filters.keyword,
          level_ids: this.filters.level,
          status: this.filters.status,
          date: this.filters.dateRange
        }
        await this.$router.replace({query: payload})
        const data = await this.$store.dispatch(GET_LIST_TUTOR, payload)
        this.mockTutors = data?.data?.map((item) => ({
          id: item.id,
          userId: item?.user_id ? String(+item.user_id + 100000) : '0',
          name: item.user_name || 'Không rõ',
          phone: item.user_phone || null,
          level: item?.academic_level_name,
          status: item.status === 1,
          created_at: moment(item.created_at).format('DD-MM-YYYY HH:mm:ss'),
        }));
        this.page = data?.pagination?.current_page
        this.lastPage = data?.pagination?.last_page
        this.totalTutor = data?.pagination?.total
      } catch (e) {

      } finally {
        this.loading = false
      }
    },
    async getListTutorLevel() {
      const data = await this.$store.dispatch(GET_LIST_TUTOR_LEVEL)
      this.levels = data.data
    },
    clickCallback(obj) {
      this.page = obj;
      this.getListTutor()
    },
    getLevelNameById(id) {
      const level = this.levels.find(item => item.id === id);
      return level ? level.name : 'Không xác định';
    },
    deleteTutor(idTutor, tutorName) {
      this.$confirm(`Bạn có chắc chắn muốn xóa nhân sự gia sư ${tutorName} không ?`, 'Xóa nhân sự gia sư', {
        confirmButtonText: 'Xác nhận',
        cancelButtonText: 'Hủy bỏ',
        type: 'warning'
      }).then(async () => {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        try {
          await this.$store.dispatch(DELETE_TUTOR, idTutor)
          this.$message({
            message: 'Xóa nhân sự thành công',
            type: 'success'
          });
          await this.getListTutor()
        } catch (e) {
          console.log('Response data:', e.response?.data); // thông tin backend trả về
          this.$message({
            showClose: true,
            message: `${e.response?.data?.message ?? 'Đã có lỗi xẩy ra'}`,
            type: 'error'
          });
        } finally {
          loading.close();
        }
      });
    },
    editTutor(idTutor, tutorName) {
      this.idTutor = idTutor
      this.$nextTick(() => {
        this.$bvModal.show('edit-tutor');
      });
    },
    openWeeklyWorkSchedule(tutor) {
      this.tutor = tutor
      this.$nextTick(() => {
        this.$bvModal.show('work-schedule-modal')
      });
    },
    openWeeklyTask(tutor) {
      this.tutor = tutor
      this.$nextTick(() => {
        this.$bvModal.show('weekly-task-modal')
      });
    }
  },
  async mounted() {
    try {
      await this.getListTutorLevel()
      const queryUrl = this.$route.query
      this.page = queryUrl?.page ?? 1
      this.filters.keyword = queryUrl?.keyword??''
      this.filters.level =  Array.isArray(queryUrl?.level_ids)?queryUrl?.level_ids.map(item=>+item):queryUrl?.level_ids?[+queryUrl?.level_ids]:[]
      this.filters.status = queryUrl.status != null ? Number(queryUrl.status) : null
      this.filters.dateRange = queryUrl?.date??[]
      await this.getListTutor()
    } catch (e) {
      console.log(e)
    }
  }
};
</script>

<style scoped>
.text-right {
  text-align: right;
}
</style>
